import React from 'react';
import Navbar from './Navbar/Navbar'

export default ({children}) => (
    <div className="App">
        {children}
    </div>
);